import {
    ON_GET_CUSTOMER_QUOTATIONS,
    GET_CUSTOMER_QUOTATIONS,
    CUSTOMER_QUOTATIONS_ERROR
} from "../types";
import customAxios from "../../utils/customAxios";
import moment from "moment";

export const getQuotations = (params) => async (dispatch) => {
    try {
        dispatch({
            type: ON_GET_CUSTOMER_QUOTATIONS,
            payload: null,
        });
        const response = await customAxios.get("/api/admin/quotations", {
            params: {
                search: params.search,
                page: 1,
                limit: 999,
                orderBy: params.orderBy,
                sortBy: params.sortBy,
                disableCalculateTotal: false,
                draw: 1,
                status: "ACTIVE,EXPIRED,DRAFT"
            },
        });
        dispatch({
            type: GET_CUSTOMER_QUOTATIONS,
            payload: response.data.data,
        });
        // return response.data.data.data[0];
    } catch (error) {
        dispatch({
            type: CUSTOMER_QUOTATIONS_ERROR,
            payload: { error: error.response },
        });
        console.error("Error fetching quotation:", error);
    }
}